import React from 'react';
import { useDispatch, useSelector } from "react-redux";
import { keyNumberAction } from "../../redux/rootReducer";
import { findKeyNumberSagaAction, saveKeyNumberSagaAction } from "../../redux/sagaActions";
import { KEY_NUMBER_FORM_INITIAL } from "../../redux/initialStateConstant";

const KeyForm = () => {
    const dispatch = useDispatch();
    const key_number = useSelector(state => state.key_number);

    if (!key_number.open) return false;

    return (
        <div className="form">
            <div className="form__scrollable">
                <div className="form__content">
                    <div className="form__header">
                        <i className="form__close" onClick={ () => {
                            dispatch(keyNumberAction(KEY_NUMBER_FORM_INITIAL));
                        } }/>
                        <div className="form__title">Укажите номер ключа</div>
                    </div>
                    <div className="form__field">
                        <div className="input__caption input__caption--required">Номер ключа</div>
                        <input type="text" className="input" autoFocus value={ key_number.number } onInput={ event => {
                            dispatch(keyNumberAction({
                                ...key_number,
                                number: event.target.value
                            }));
                        } } />
                    </div>
                    <div className="form__field">
                        <div className="button"
                            onClick={ () => {
                                // Если добавляем ключ
                                if (key_number.type === 'save') {
                                    dispatch(saveKeyNumberSagaAction({
                                        key_number: key_number.number,
                                        workout_id: key_number.workout_id
                                    }));
                                }
                                // Если ищем ключ
                                else if (key_number.type === 'find') {
                                    dispatch(findKeyNumberSagaAction({
                                        key_number: key_number.number
                                    }));
                                }
                            } }
                        >{ key_number.type === 'save' ? 'Сохранить' : 'Найти' }</div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default KeyForm;